module.exports = __webpack_public_path__ + "img/huoche.002848c6.png";